import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=a039cd94&"
import script from "./Dashboard.vue?vue&type=script&lang=js&"
export * from "./Dashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\MasterBranches\\Maintenance_06.04\\Fontes\\corp\\produto\\wes\\WebApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a039cd94')) {
      api.createRecord('a039cd94', component.options)
    } else {
      api.reload('a039cd94', component.options)
    }
    module.hot.accept("./Dashboard.vue?vue&type=template&id=a039cd94&", function () {
      api.rerender('a039cd94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "content/components/Financeiro/Dashboard.vue"
export default component.exports